<template>
    <div>
        <div style="width: 100%;margin-bottom: 20px;">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>积分商品管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 搜索筛选 -->
        <el-form :inline="true" class="user-search" :model="formInline" size="small">

            <el-form-item label="商品名称">
                <el-input size="small" placeholder="请输入商品名称" v-model="formInline.goodsname"></el-input>
            </el-form-item>

            <el-form-item label="上架状态">
                <el-select v-model="formInline.status" placeholder="默认全部">
                    <el-option label="全部" value='-1'></el-option>
                    <el-option label="下架" value='0'></el-option>
                    <el-option label="上架" value='1'></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="销量">
                <el-input v-model="formInline.mixSale" style="width: 80px;"></el-input>
                -
                <el-input v-model="formInline.maxSale" style="width: 80px;"></el-input>
            </el-form-item>
            <el-form-item label="价格">
                <el-input v-model="formInline.minpreice" style="width: 80px;"></el-input>
                -
                <el-input v-model="formInline.maxpreice" style="width: 80px;"></el-input>
            </el-form-item>


            <!-- <el-form-item label="一级分类">
                <el-select v-model="formInline.status" placeholder="默认全部">
                  
                    <el-option label="下架" value='0'></el-option>
                    <el-option label="上架" value='1'></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="二级分类">
                <el-select v-model="formInline.status" placeholder="默认全部">
                    <el-option label="下架" value='0'></el-option>
                    <el-option label="上架" value='1'></el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                <el-button size="small" type="warning" icon="el-icon-delete" @click="add">新增</el-button>
                <el-button size="small" type="warning" icon="el-icon-delete" @click="clear">清空刷选条件</el-button>

            </el-form-item>
        </el-form>

        <!--列表-->
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" type="selection" width="60">
            </el-table-column>
            <el-table-column prop="goodsName" label="产品名称" width="150" align="center">
                <template slot-scope="scope">
                    <div>
                        <el-image style="width: 80px; height: 80px" :src="scope.row.bannerImgList[0]">
                        </el-image>
                    </div>
                    <div>{{scope.row.goodsName}}</div>
                </template>

            </el-table-column>
            <el-table-column prop="exchangePoints" label="所需积分" width="150" align="center">
            </el-table-column>
            <!-- <el-table-column prop="seeNum" label="访问量" width="200" align="center">
                <template slot-scope="scope">

                    <div>访问量：{{scope.row.seeNum}}</div>
                    <div>访客数：{{scope.row.visitNum?scope.row.visitNum:0}}</div>
                </template>
            </el-table-column> -->

            <el-table-column prop="exchangedInit" label="初始兑换值" width="100" align="center">
            </el-table-column>
            <el-table-column prop="exchangedAmount" label="已兑换" width="100" align="center">
            </el-table-column>
            <el-table-column prop="exchangeEndTime" label="有效期" width="250" align="center">
                <template slot-scope="scope">

                    <div>{{web.formatTime(scope.row.exchangeStartTime,'Y-M-D h:m')}}-{{web.formatTime(scope.row.exchangeEndTime,'Y-M-D h:m')}}</div>
                   
                </template>
            </el-table-column>
            <el-table-column prop="purchaseLimit" label="每人限兑份数" width="100" align="center">
            </el-table-column>
         
            <el-table-column align="center" label="操作" min-width="300">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" icon="el-icon-edit"
                        @click="handleedit(scope.$index, scope.row)">编辑</el-button>              
                    <el-button size="mini" type="primary" icon="el-icon-delete"
                    @click="handledelete(scope.$index, scope.row)">删除</el-button>
  
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <Pagination :child-msg="pageparm" @callFather="callFather"></Pagination>

        <!-- 弹框 -->
        <!-- 回复评论 -->

       <el-dialog
      :close-on-click-modal="false" title="商品编辑" :visible.sync="Visible" width="50%" @click="closeDialog" center>

            <el-form class="user-search" :model="editForm" label-width="120px" inline label-position="right" size="small">

                <el-form-item label="商品名称：">
                    <el-input size="small" placeholder="请输入订单编号" v-model="editForm.goodsName">
                    </el-input>
                </el-form-item>
                <el-form-item label="所属类别：">
                    <el-cascader v-model="value" :options="tableData"
                        :props="{checkStrictly: true, label: 'catename' , value: 'cateid'}" clearable
                        @change="changecascader">

                    </el-cascader>
                </el-form-item>

                <el-form-item label="卖点：">
                    <el-input size="small" placeholder="请输入订单编号" v-model="editForm.sellPoint">
                    </el-input>
                </el-form-item>

                <el-form-item label="库存：">
                    <el-input size="small" placeholder="请输入订单编号" v-model="editForm.stock"></el-input>
                </el-form-item>
                <el-form-item label="虚拟库存：">
                    <el-input size="small" placeholder="请输入订单编号" v-model="editForm.fictitiousStock">
                    </el-input>
                </el-form-item>
                <el-form-item label="销量：">
                    <el-input size="small" placeholder="请输入订单编号" v-model="editForm.saleNum"></el-input>
                </el-form-item>
                <el-form-item label="预计销量：">
                    <el-input size="small" placeholder="请输入订单编号" v-model="editForm.initSaleNum">
                    </el-input>
                </el-form-item>
                <div style="font-weight: 500;font-size: 20px;">价格设置</div>
                <el-form-item label="出售价格：">
                    <el-input size="small" placeholder="请输入订单编号" v-model="editForm.salePrice">
                    </el-input>
                </el-form-item>
                <el-form-item label="vip价格：">
                    <el-input size="small" placeholder="请输入订单编号" v-model="editForm.vipPrice">
                    </el-input>
                </el-form-item>
                <el-form-item label="vip价格：">
                    <el-input size="small" placeholder="请输入订单编号" v-model="editForm.marketPrice">
                    </el-input>
                </el-form-item>
                <el-form-item label="加购价格：">
                    <el-input size="small" placeholder="请输入订单编号" v-model="editForm.addPrice">
                    </el-input>
                </el-form-item>
                <el-form-item label="折扣：">
                    <el-input size="small" placeholder="请输入订单编号" v-model="editForm.discount">
                    </el-input>
                </el-form-item>
                <div style="font-weight: 500;font-size: 20px;">图片管理</div>
                <div class="just-start marginT20">
                    <div>首页主图：</div>
                    <unload @upload="upload" cateName="mainImg" :limit="1"
                        :list="editForm.mainImg?[web.obj(editForm.mainImg)]:[]"></unload>
                </div>

                <div class="just-start marginT20">
                    <div>首页封面图：</div>
                    <unload @upload="upload" cateName="indexImg" :limit="1"
                        :list="editForm.indexImg?[web.obj(editForm.indexImg)]:[]"></unload>
                </div>
                <div class="just-start marginT20">
                    <div>商品主图：</div>
                    <unload @upload="upload" cateName="coverImg" :limit="1"
                        :list="editForm.coverImg?[web.obj(editForm.coverImg)]:[]"></unload>
                </div>

                <div class="just-start marginT20">
                    <div>视频主图：</div>
                    <unload @upload="upload" cateName="videoImg" :list="[web.obj(editForm.videoImg)]" :limit="1">
                    </unload>
                </div>
                <div class="just-start marginT20">
                    <div>上传视频：</div>
                    <unload @upload="upload" cateName="videoUrl" :list="[web.obj(editForm.videoUrl)]" type="vedio"
                        accept=".mp4,/vedio/mp4"></unload>
                </div>
                <div>
                    <el-form-item label="轮播图：" style="width: 100%;">
                        <el-upload action="https://testm.chunpinkeji.com/api/uploadFileOss" list-type="picture-card"
                            class="upload-demo" multiple :on-preview="handlePictureCardPreview"
                            :on-remove="handleRemove" :on-success="handleSuccess" :limit="4" :file-list="fileList"
                            :on-exceed="handleExceed">
                            <i class="el-icon-plus"></i>
                        </el-upload>

                       <el-dialog
      :close-on-click-modal="false" :visible.sync="dialogVisible">
                            <img width="100%" :src="dialogImageUrl" alt="" v-if="dialogImageUrl">
                        </el-dialog>
                    </el-form-item>
                </div>
                <div class="just-start marginT20">
                    <div>全屏图左：</div>

                    <unload @upload="upload" cateName="fullScreenImg" :imgurl="editForm.fullScreenImg"></unload>

                </div>
                <div class="just-start marginT20">
                    <div>全屏图右：</div>

                    <unload @upload="upload" cateName="fullScreenImgRight" :imgurl="editForm.fullScreenImgRight">
                    </unload>

                </div>

                <el-form-item label="上下架：">
                    <el-select v-model="formInline.isSale" placeholder="默认全部">
                        <el-option label="下架" value='0'></el-option>
                        <el-option label="上架" value='1'></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label="上架时间：">
                    <el-input size="small" placeholder="请输入上架时间" v-model="editForm.presaleTime">
                    </el-input>
                </el-form-item>
                <el-form-item label="促销商品：">
                    <el-select v-model="formInline.isSale" placeholder="否">
                        <el-option label="否" value='0'></el-option>
                        <el-option label="是" value='1'></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="限购数量：">
                    <el-input size="small" placeholder="请填写限购数量" v-model="editForm.purchaseLimit">
                    </el-input>
                </el-form-item>
                <div style="font-weight: 500;font-size: 20px;">秒杀活动设置</div>
                <el-form-item label="商品顺序：">
                    <el-input size="small" placeholder="秒杀商品排序" v-model="editForm.seckillIndex" >
                    </el-input>
                </el-form-item>
                <el-form-item label="开始时间：">
                    <el-input size="small" placeholder="秒杀开始时间" v-model="editForm.seckillStarttime" >
                    </el-input>
                </el-form-item>
                <el-form-item label="持续时长：">
                    <el-input size="small" placeholder="持续时间的长度" v-model="editForm.seckillStarttime" >
                    </el-input>
                </el-form-item>
                <el-form-item label="场次：">
                    <el-input size="small" placeholder="请输入场次" v-model="editForm.seckillSessions" >
                    </el-input>
                </el-form-item>
                <el-form-item label="场次：">
                    <el-input size="small" placeholder="请输入订单编号" v-model="editForm.seckillSessions" >
                    </el-input>
                </el-form-item>
                <div style="font-weight: 500;font-size: 20px;">新品设置</div>
                <el-form-item label="新品顺序：">
                    <el-input size="small" placeholder="新品排序" v-model="editForm.newIndex" >
                    </el-input>
                </el-form-item>


            </el-form>
            
            <quill-edit @content="getContent"></quill-edit>

            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="submitreplyForm">保存
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import quillEdit from '../../components/quillEdit'
    import { deletePointGoods , pointGoodsList , savePointGoods , pointGoodsDetail } from '../../api/basisMG.js'
    import Pagination from '../../components/Pagination'
    import unload from '../../components/upload'
    // 导出模块
    export default {
        components: {
            Pagination,
            quillEdit,
            unload
        },
        // 模块数据
        data() {
            //数据  
            return {
                loading: false,
                Visible: false,

                formInline: {
                    start: 0,
                    length: 5,
                    goodsname: '',
                    status: '',
                    mixSale: null,
                    maxSale: null,
                    minpreice: null,
                    maxpreice: null,
                    cateId: '',
                    cateId2: '',
                },
                fileList: [],
                listData: [],
                dialogImageUrl: '',
                dialogVisible: false,
                // 分页参数
                pageparm: {
                    currentPage: 1,
                    pageSize: 5,
                    total: 10,
                    start: 0,
                    length: 5
                },
                // 所属分类
                tableData: [],
                value: [],
                editForm: {
                    goodsId: '',
                    goodstype: '',
                    goodsName: '',
                    des: '',
                    SelectValue: '',
                    goodsdes: '',
                    sellPoint: '',
                    specications: '',
                    price: null,
                    marketPrice: null,
                    stock: 999,
                    saleNum: 0,
                    purchaseLimit: 0,
                    day: '',
                    time: '',
                    imglunbo: '',
                    videoUrl: '',
                    videoImg: '',
                    mainImg: '',
                    indexImg: '',
                    freightFee: '',
                    cateId: null,
                    cateId2: null,
                    stockThresholdType: null,
                    stockThreshold: 100,
                    uploadData: []
                }
            }
        },


        watch: {},

        methods: {
            submitreplyForm() {
                console.log(this.editForm)
                savePointGoods(this.editForm).then(res => {
                    if (res.code == '200') {
                        this.listData = res.data.content
                        this.pageparm.total = res.data.totalElements
                        this.getdata()
                    }
                })
            },
            // 单个图片上传可用
            upload(data, cateName, limit) {
                if (limit == 1) {
                    this.editForm[cateName] = data[0].response.data
                }

                console.log(data, cateName)
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            //  图片上传
            handleRemove(file, fileList) {
                // this.editForm.fileList = fileList
                this.fileList = fileList
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleSuccess(response, file, fileList) {

                this.fileList = fileList
                this.dialogImageUrl = response.data


            },
            handleSuccess1(response, file, fileList) {

                this.uploadData = fileList
                this.editForm.indexImg = response.data

            },
            changecascader(e) {
                console.log(e)

            },
            getContent(content) {

                this.editForm.des = content
            },
            pointGoodsDetail() {
                //   获得积分兑换详情
                pointGoodsDetail().then(res => {
                    if (res.code == '200') {
                        this.tableData = res.data

                    }

                })
            },


            // 评论框
            closeDialog() {
                this.Visible = false

            },
            
            postopen() { },
            // 获得商品数据
            getdata(params) {
                let param = params
              
                pointGoodsList(param).then(res => {
                    this.saveParams(this.$route.path,param)
                    if (res.code == '200') {
                        res.data.content.map(item=>{
                            item.bannerImgList = JSON.parse(item.coverImg)
                        })
                        this.listData = res.data.content
                        this.pageparm.total = res.data.totalElements
                    }
                })

            },
            add() {
                this.$router.push({path:'/product/productedit'})
                // this.Visible = true
                // console.log('add')
                // this.editForm = {}
            },
            // 获得商品数据
            addEdit() {
                this.Visible = true
            },
            handleedit(index, row) {
                // this.Visible = true
                this.editForm = Object.assign({}, row)
                let list = []
                list = row.bannerImg.split(",")
                list.forEach(item => {
                    
                    this.fileList.push(this.web.obj(item))
                })

                this.editForm.fileList = this.fileList
               
                this.$router.push({path:'/point/pointProductedit',query: {editForm: JSON.stringify(this.editForm),id:1}})
                console.log(this.editForm.fileList)
                console.log(index, row)
            },
            handledelete(index, row) {
                console.log(index, row)
                deletePointGoods({ goodsId: row.goodsId }).then(res => {
                    console.log(res)
                    if (res.code == 200) {
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        })
                        this.getdata(this.formInline)
                    }

                })
            },
            // 查询
            // search() {
            //     this.formInline.start = 0
			// 	this.pageparm.currentPage = 1
            //     this.getdata(this.formInline)
            // },
            // 清空
            // clear() {
            //     this.formInline = {
            //         start: 0,
            //         length: 10,
            //         goodsname: '',
            //         status: '',
            //         mixSale: null,
            //         maxSale: null,
            //         minpreice: null,
            //         maxpreice: null,
            //         cateId: '',
            //         cateId2: '',
            //     },
            //         this.getdata(this.formInline)
            // },

            // 分页插件事件
            // callFather(parm) {
            //     this.pageparm.currentPage  = parm.currentPage
            //     this.pageparm.pageSize =  parm.pageSize 
            //     this.pageparm.start  = parm.currentPage - 1
            //     this.pageparm.length =  parm.pageSize 
            //     this.formInline.start = parm.currentPage - 1
            //     this.formInline.length = parm.pageSize
            //     this.getdata(this.formInline)
            // },
            addFun() { },
            submitFun() { }
        },
        // 创建前状态(里面是操作)
        beforeCreate() { },
        // 创建完毕状态(里面是操作)
        created() {
            this.getParams(this.$route.path)
            this.getdata(this.formInline)
           
        },
        // 挂载前状态(里面是操作)
        beforeMount() { },
        // 挂载结束状态(里面是操作)
        mounted() { },
        // 更新前状态(里面是操作)
        beforeUpdate() { },
        // 更新完成状态(里面是操作)
        updated() { },
        // 销毁前状态(里面是操作)
        beforeDestroy() { },
        // 销毁完成状态(里面是操作)
        destroyed() { }
    };
</script>

<style scoped>
    .el-form-item {
 
        box-sizing: border-box;
    }

    .just-start {
        display: flex;
        justify-content: flex-start;
    }

    .marginT20 {
        margin-top: 20px;
    }
</style>